<div class="back">
    <div class="back-image" *ngIf="!paramTokenAcesso" [style.background-image]="'url(/assets/login/sign-in-background-token.jpg)'"></div>
    <div class="back-image" *ngIf="paramTokenAcesso" [style.background-image]="'url(/assets/login/sign-in-background-credentials.jpg)'"></div>

    <div class="container flex flex-column justify-content-center align-items-center">
        <p-card class="shadow" header="">
            <ng-template pTemplate="header">
                <app-logo [paramChave]="paramTokenAcesso" [loadingEmpresa]="loadingEmpresa" [width]="'auto'"></app-logo>
            </ng-template>

            <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                <div class="field" *ngIf="!paramTokenAcesso">
                    <div class="card flex flex-wrap justify-content-center gap-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-cog"></i>
                            <input type="text" [(ngModel)]="tokenAcesso" placeholder="Token de acesso" pInputText />
                        </span>
                    </div>
                </div>

                <div class="field" *ngIf="paramTokenAcesso">
                    <div class="card flex flex-wrap justify-content-center gap-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"></i>
                            <input type="text" [(ngModel)]="usuario.usuario" placeholder="Usuário" pInputText (change)="changeUsuario()" />
                        </span>
                    </div>
                </div>

                <div class="field" *ngIf="paramTokenAcesso">
                    <p-password placeholder="Senha" [(ngModel)]="usuario.senha" [toggleMask]="true" [feedback]="false"></p-password>
                </div>

                <p class="color-error" *ngIf="erroLogin">{{ erroLogin }}</p>
                <p class="color-error" *ngIf="empresaErro">Empresa não encontrada!</p>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                    <div class="pb-5">
                        <p-button class="btn-bg-primary" label="Entrar" (click)="logar()" *ngIf="paramTokenAcesso" [loading]="loading" [disabled]="loginBloqueado"></p-button>
                        <p-button class="btn-bg-primary" label="Continuar" (click)="selecionarCodigoEmpresa()" *ngIf="!paramTokenAcesso" [disabled]="!tokenAcesso" [loading]="loadingEmpresa"></p-button>
                    </div>
                    <div class="field" *ngIf="!paramTokenAcesso">
                        <a href='https://oticom.com.br/' target="_blank">Abrir site do ÓTICOM</a>
                    </div>
                    <div class="field">
                        <a href='https://embrati.inf.br/' target="_blank">Copyright EMBRATI</a>
                    </div>

                    <div class="field" *ngIf="paramTokenAcesso">
                        <i class="pi pi-fw pi-comments"></i>
                        <a href='https://chat.movidesk.com/ChatWidget/Landing/EBAB88DAB1D94FC8BB6133FCCD9DD3A5' target="_blank">Chat Suporte</a>
                    </div>
                </div>
            </ng-template>
        </p-card>
    </div>
</div>